export default () => ({
  appUrl: '',
  browserSupport: {
    webGl: true,
  },
});
